<template>
  <a-card size="small" title="筛选条件" :bordered="false">
    <a-form-model layout="inline" class="search-form1">
      <a-form-model-item label="未设计天数" prop="noDesignDay">
        <a-input-number v-model="form.noDesignDay" :min="0" :max="30" @change="handleChange" />
      </a-form-model-item>
      <a-form-model-item label="未开发天数" prop="noDevDay">
        <a-input-number v-model="form.noDevDay" :min="0" :max="30" @change="handleChange" />
      </a-form-model-item>
      <a-form-model-item label="产品PO" prop="po">
        <a-select v-model="form.po" style="width: 200px;" mode="multiple" allow-clear placeholder="请选择产品PO" :filter-option="utils.filterOption" @change="handleChange">
          <a-select-option v-for="(user, index) in brPoList" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item requirement-type label="时间筛选" :label-col="{ span: 3 }">
        <a-input-group compact>
          <a-select v-model="form.searchTimeType" style="width: 26%" @change="handleChange">
            <a-select-option :value="135"> PRD设计时间 </a-select-option>
            <a-select-option :value="149"> PRD完成 </a-select-option>
            <a-select-option :value="136"> PRD评审完成 </a-select-option>
            <a-select-option :value="138"> 验收时间 </a-select-option>
          </a-select>
          <a-date-picker v-model="form.startTime" style="width: 37%" placeholder="开始时间" value-format="YYYY-MM-DD" @change="handleChange" />
          <a-date-picker v-model="form.endTime" style="width: 37%" placeholder="结束时间" value-format="YYYY-MM-DD" @change="handleChange" />
        </a-input-group>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import store from '@/store';
export default {
  name: 'DataFilter',
  data() {
    return {
      form: {
        searchTimeType: 135,
        noDesignDay: 5,
        noDevDay: 20,
        po: [],
        startTime: '',
        endTime: ''
      }
    };
  },

  computed: {

    brPoList() {
      const list = [];
      if (store.state.globalConfigList) {
        const orgList = store.state.globalConfigList.br_po || [];
        return orgList.map(item => {
          return {
            nickname: item.nickname,
            id: item.user_id
          };
        });
      }
      return list;
    }
  },

  watch: {
    filter() {
    }
  },
  created() {
    this.handleChange();
  },

  methods: {
    handleChange() {
      this.$emit('change', this.form);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.search-form1 .ant-form-item {
  display: inline-block !important;
}
.ant-form-item {
  margin-bottom: 0px;
}

</style>
